export var renderFilterViewerDateConditionValue = function renderFilterViewerDateConditionValue(condition, conditionType, conditionValue) {
  var multiple = condition.multiple;

  var _ref = conditionValue || {},
      value = _ref.value;

  var _conditionType$getAtt = conditionType.getAttributes(),
      formatDateTime = _conditionType$getAtt.formatDateTime;

  if (multiple) {
    return '';
  }

  if (value === undefined || value === null) {
    return '';
  }

  var result = '';

  if (formatDateTime && value instanceof Date) {
    result = formatDateTime(value);
  } else {
    result = value.toString();
  }

  return result;
};